<template>
    <p
        v-if="value"
        v-html="value"
        class="title font-weight-light short-description mt-2 text-styles"
    ></p>
</template>

<style scoped>
.short-description {
    margin-bottom: 0;
}

.short-description p {
    margin-bottom: 0;
}
.text-styles p {
    margin-bottom: 0;
}

.text-styles ul, ol {
    padding-left: 0;
}

.text-styles li {
    padding-bottom: 3px;
}

.text-styles br {
    display: none;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

const parentModuleName = 'Product';
const {mapState, mapGetters} = createNamespacedHelpers(parentModuleName);
import {ProductShortDescription} from '@breakmedia/prime-vue-product/src/product-page/ProductShortDescription.vue';

export default {
    extends: ProductShortDescription,
    computed: {
        value() {
            return this.getProductAttributeByLanguage(this.product, 'product.description.short');
        },
        ...mapState(['product']),
        ...mapGetters(['getProductAttributeByLanguage'])
    },
};
</script>